import { FormControl, FormHelperText } from "@mui/material";
import { FC } from "react";
import { Controller, useFormContext } from "react-hook-form";

import { FullWidthTextFieldWrapper } from "@ryde/controls";
import { useDynamicFormsTranslate } from "@ryde/redux";
import { ICustomField, ILocationInfo } from "@ryde/shared";

import { AddressBlock } from "../../map";

const EMPTY_COORDINATE_ADDRESS: ILocationInfo = { fullAddress: "" };

export const AddressTemplate: FC<ICustomField> = ({
  id,
  name,
  formLabel,
  formAttributes,
  formValidation,
  e2eData = "address-template",
}) => {
  const { control, setValue } = useFormContext();
  const { formLabelTranslated } = useDynamicFormsTranslate({
    name,
    fallbackText: formLabel,
  });

  const defaultValue = formAttributes?.isCoordinate
    ? EMPTY_COORDINATE_ADDRESS
    : "";

  const onChange = (value: Partial<ILocationInfo>): void => {
    const newValue = formAttributes?.isCoordinate ? value : value.fullAddress;

    setValue(name as string, newValue, {
      shouldDirty: true,
      shouldValidate: true,
    });
  };

  return (
    <FullWidthTextFieldWrapper>
      <Controller
        name={name}
        control={control}
        render={({ field, fieldState: { error } }) => (
          <FormControl
            data-e2e={e2eData}
            data-e2e-field-name={name}
            data-e2e-id={`${name}_${id || ""}`}
            error={!!error}
          >
            <AddressBlock
              value={field.value || defaultValue}
              label={formLabelTranslated}
              onChange={onChange}
              error={!!error}
              formValidation={formValidation}
              disabled={formAttributes?.disabled}
            />
            {error && <FormHelperText>{error.message}</FormHelperText>}
          </FormControl>
        )}
      />
    </FullWidthTextFieldWrapper>
  );
};
